import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import Global from '../../../store/global-selectors';
import style from './new-order-modal.module.less';
import messages from './messages';
import OrderSummary from './order-summary';
import { EditOrderRequestPropType } from '../../../prop-types/edit-order-request';
import { MarketplaceIds } from '../../../enums/marketplace-ids';

export const OrderSummaryInformation = ({ autoGenerateOrderNumber, setAutoGenerateOrderNumber, fieldsWithError, order, setOrder }) => {
  const stores = useSelector((state) =>
    Global.selectSellerStores(state).filter((store) => store.isActive && store.marketplaceId === MarketplaceIds.ShipStation),
  );
  const userDateFormat = useSelector(Global.selectUserUserDateFormat);

  const onOrderUpdated = useCallback(
    (field, value) => {
      if (field === 'storeGuid') {
        const selectedStore = stores.find((x) => x.storeGuid === value);
        if (selectedStore) {
          setOrder({
            ...order,
            [field]: value,
          });
          setAutoGenerateOrderNumber(selectedStore.willAutoGenOrderNumber || false);
          return;
        }
      }
      setOrder({
        ...order,
        [field]: value,
      });
    },
    [order, setOrder, stores, setAutoGenerateOrderNumber],
  );

  const onAmountSummaryUpdated = useCallback(
    (field, value) => {
      const amountSummary = { ...order.amountSummary };
      amountSummary[field] = value;
      onOrderUpdated('amountSummary', amountSummary);
    },
    [order, onOrderUpdated],
  );

  const toggleAutoGeneratedOrderNumber = useCallback(() => {
    setAutoGenerateOrderNumber(!autoGenerateOrderNumber);
    setOrder({
      ...order,
      orderNumber: '',
    });
  }, [autoGenerateOrderNumber, setAutoGenerateOrderNumber, order, setOrder]);

  return (
    <div className={style['order-summary-container']}>
      <div className={style['section-title']}>
        <FormattedMessage {...messages.orderSummaryTitle} />
      </div>
      <OrderSummary
        autoGenerateOrderNumber={autoGenerateOrderNumber}
        fieldsWithError={fieldsWithError}
        onAmountSummaryUpdated={onAmountSummaryUpdated}
        onOrderUpdated={onOrderUpdated}
        order={order}
        stores={stores}
        toggleAutoGeneratedOrderNumber={toggleAutoGeneratedOrderNumber}
        userDateFormat={userDateFormat}
      />
    </div>
  );
};

OrderSummaryInformation.propTypes = {
  autoGenerateOrderNumber: PropTypes.bool.isRequired,
  setAutoGenerateOrderNumber: PropTypes.func.isRequired,
  fieldsWithError: PropTypes.object.isRequired,
  order: EditOrderRequestPropType.isRequired,
  setOrder: PropTypes.func.isRequired,
};
